export enum COOKIES {
    GUEST_DATA = "guestData",
    COUNTRY_CODE = "countryCode",
    IP_ADDRESS = "ipAddress",
    VERCEL_CANARY_ID = "vercelCanaryId",
    CART_SLUGS = "ib-cart-slugs",
    VCRR = "vcrr",
    GCLID = "gclid",
    GBRAID = "gbraid",
    WBRAID = "wbraid",
    VISITOR_UUID = "visitor-uuid",
}
